<template>
    <el-menu v-bind="$attrs" v-on="$listeners">
        <el-menu-item index="/workbench" v-if="showWorkbench && showMenu('Workbench')">
            <i class="iconfont icon-workbench"></i>
            <span slot="title">{{ $t('menu.overview') }}</span>
        </el-menu-item>
        <el-menu-item index="/monitor_manage/monitor" v-if="showMenu('MonitorView')">
            <i class="iconfont icon-monitor"></i>
            <span slot="title">{{ $t('menu.monitor') }}</span>
        </el-menu-item>
        <el-menu-item index="/data_stat_manage/data-stat-list" v-if="showMenu('DataStatList')">
            <i class="iconfont icon-stat"></i>
            <span slot="title">{{ $t('menu.data_stat') }}</span>
        </el-menu-item>
        <el-menu-item index="/stat/overview" v-if="showMenu('StatOverview') && isTh">
            <i class="iconfont icon-xianshishezhi"></i>
            <span slot="title">{{ $t('menu.data_overview') }}</span>
        </el-menu-item>
        <el-submenu index="/business_manage" v-if="showMenuGroup(['NoFlyZoneList', 'DroneList'])">
            <template slot="title">
                <i class="iconfont icon-yewu"></i>
                <span>{{ $t('menu.business_management') }}</span>
            </template>
            <el-menu-item index="/business_manage/no-fly-zone-list" v-if="showMenu('NoFlyZoneList')">{{ $t('menu.no_fly_zone') }}</el-menu-item>
            <el-menu-item index="/business_manage/accessory-white-list" v-if="showMenu('PartWhiteList')">{{ $t('menu.part_white_list') }}</el-menu-item>
            <el-menu-item index="/business_manage/drone-model-list" v-if="showMenu('DroneModelList')">{{ $t('menu.model_management') }}</el-menu-item>
            <el-menu-item index="/business_manage/drone-list" v-if="showMenu('DroneList')">{{ $t('menu.drone_management') }}</el-menu-item>
            <el-menu-item index="/business_manage/block-list" v-if="showMenu('BlockList')">{{ $t('menu.field_management') }}</el-menu-item>
            <el-menu-item index="/business_manage/group-control" v-if="showMenu('GroupControl')">{{ $t('menu.group_control') }}</el-menu-item>
            <el-menu-item index="/business_manage/unified-task-list" v-if="showMenu('UnifiedTaskList')">{{ $t('menu.unified_task') }}</el-menu-item>
            <el-menu-item index="/business_manage/flight-control" v-if="showMenu('FlightControl')">{{ $t('menu.flight_control') }}</el-menu-item>
            <el-menu-item index="/business_manage/tools" v-if="showMenu('Tools')">{{ $t('menu.tools') }}</el-menu-item>
            <el-menu-item index="/business_manage/app-log" v-if="showMenu('AppLog')">{{ $t('menu.ground_station_log') }}</el-menu-item>
            <el-menu-item index="/business_manage/firmware-list" v-if="showMenu('FirmwareManage')">{{ $t('menu.firmware_management') }}</el-menu-item>
            <el-menu-item index="/business_manage/ground-station-config" v-if="showMenu('GroundStationConfig')">{{ $t('menu.ground_station') }}</el-menu-item>
        </el-submenu>
        <el-submenu index="/institution_manage" v-if="showMenuGroup(['AccountList', 'AccountApplyList', 'MemberList', 'SystemLogList'])">
            <template slot="title">
                <i class="iconfont icon-enterprise"></i>
                <span>{{ $t('menu.organization') }}</span>
            </template>
            <el-menu-item index="/institution_manage/account-list" v-if="showMenu('AccountList')">{{ $t('menu.accounts') }}</el-menu-item>
            <el-menu-item index="/institution_manage/account-apply-list" v-if="showMenu('AccountApplyList')">{{ $t('menu.account_audit') }}</el-menu-item>
            <el-menu-item index="/institution_manage/user-apply-list" v-if="showMenu('UserApplyList')">{{ $t('menu.user_audit') }}</el-menu-item>
            <el-menu-item index="/institution_manage/member-list" v-if="showMenu('MemberList')">{{ $t('menu.members') }}</el-menu-item>
            <!--<el-menu-item index="/institution_manage/order-list" v-if="showMenu('OrderList')">{{ $t('menu.orders') }}</el-menu-item>-->
            <!--<el-menu-item index="/institution_manage/invoice-list" v-if="showMenu('InvoiceList')">{{ $t('menu.invoices') }}</el-menu-item>-->
            <el-menu-item index="/institution_manage/system-log-list" v-if="showMenu('SystemLogList')">{{ $t('menu.system_log') }}</el-menu-item>
        </el-submenu>
        <el-submenu index="/bulletin_manage" v-if="showMenuGroup(['BulletinList', 'BulletinCreate'])">
            <template slot="title">
                <i class="iconfont icon-notice"></i>
                <span>{{ $t('menu.announcement_management') }}</span>
            </template>
            <el-menu-item index="/bulletin_manage/bulletin-list" v-if="showMenu('BulletinList')">{{ $t('menu.announcement') }}</el-menu-item>
            <el-menu-item index="/bulletin_manage/bulletin-create" v-if="showMenu('BulletinCreate')">{{ $t('menu.send_announcement') }}</el-menu-item>
        </el-submenu>
        <el-menu-item @click="onShowSettings">
            <i class="iconfont icon-settings"></i>
            <span slot="title">{{ $t('settings.label') }}</span>
        </el-menu-item>
        <el-menu-item @click="handleLogout" v-if="showLogout">
            <i class="iconfont icon-pwoer-off"></i>
            <span slot="title">{{ $t('menu.sign_out') }}</span>
        </el-menu-item>
    </el-menu>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import logoutMixin from '../../mixins/logoutMixin';
    import settingMixin from '../../mixins/settingMixin';

    export default {
        name: 'AccountMenu1',

        mixins: [logoutMixin, settingMixin],

        props: {
            showLogout: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            ...mapGetters('user', ['showMenu', 'showMenuGroup']),
            ...mapState('theme', ['showWorkbench']),
            ...mapGetters('lang', ['isTh']),
        },
    };
</script>

<style lang="scss" scoped>
</style>
